import axios from '../http/axios';
import { PORTAL_SERVICOS_BACKEND } from '../constants/environment';

const BASE_URL_ITEMMENU = `${PORTAL_SERVICOS_BACKEND}/frontend/v1/itemmenu`;

export default {
	consultarPorCodigo: codigo => {
		return axios.get(`${BASE_URL_ITEMMENU}/consultar/${codigo}`).then(res => {
			return res.data;
		});
	},
	consultarProximaOrdem: () => {
		return axios.get(`${BASE_URL_ITEMMENU}/proximo`).then(res => {
			return res.data;
		});
	},
	consultarPorFiltro: filtro => {
		if (!filtro.page) {
			filtro.page = 0;
		}
		if (!filtro.size) {
			filtro.size = 5;
		}
		return axios.post(`${BASE_URL_ITEMMENU}/consultar`, filtro).then(res => {
			return res.data;
		});
	},
	consultarItensMenuPublicados: () => {
		return axios.get(`${BASE_URL_ITEMMENU}/publicados`).then(res => {
			return res.data;
		});
	},
	salvar: itemMenu => {
		return axios.post(`${BASE_URL_ITEMMENU}/salvar`, itemMenu).then(res => {
			return res.data;
		});
	},
	remover: codigo => {
		return axios
			.delete(`${BASE_URL_ITEMMENU}/remover`, { data: { codigo } })
			.then(res => {
				return res.data;
			});
	}
};
